import { SignInButton, SignedIn, SignedOut } from '@clerk/clerk-react'

export default function LandingHeader() {
  const clerkAppearance = {
    variables: {
      colorBackground: '#0b0b0b',
      colorInputBackground: '#0f0f0f',
      colorPrimary: '#ffffff',
      colorText: '#ffffff',
      colorTextSecondary: '#cdd1d5',
      colorInputText: '#ffffff',
    },
    elements: {
      modal: 'bg-black/90 backdrop-blur',
      card: 'bg-[#0b0b0b] border border-white/10 shadow-[0_0_80px_rgba(0,0,0,0.6)]',
      headerTitle: 'text-white uppercase tracking-[0.2em] text-sm',
      headerSubtitle: 'text-zinc-400 text-xs',
      formFieldLabel: 'text-zinc-300 text-[11px] uppercase tracking-[0.2em]',
      formFieldInput: 'text-white bg-zinc-900 border-white/20',
      formButtonPrimary: 'bg-white text-black hover:bg-zinc-200 text-xs font-bold uppercase tracking-[0.2em]',
      footerActionLink: 'text-white hover:text-zinc-200',
    },
  }

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-white/10">
      <nav className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo + Badge */}
        <div className="flex items-center gap-4">
          <a href="/" className="flex items-center gap-2">
            <img src="/otd-logo.svg" alt="OTD Logo" className="h-8" />
          </a>
          <span className="px-2 py-0.5 border border-emerald-500/50 text-emerald-500 bg-emerald-500/10 text-[8px] font-bold uppercase tracking-widest">
            MAINNET
          </span>
        </div>
        
        {/* Right Section */}
        <div className="flex items-center gap-4">
          <a
            href="https://openthedoorz.gitbook.io/open-the-doorz/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400 hover:text-white transition-colors"
          >
            DOCS
          </a>
          
          <SignedOut>
            <SignInButton mode="modal" appearance={clerkAppearance}>
              <button className="px-6 py-2 bg-white text-black text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-zinc-200 transition-all">
                WALLET
              </button>
            </SignInButton>
          </SignedOut>
          
          <SignedIn>
            <a
              href="/dashboard"
              className="px-6 py-2 bg-white text-black text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-zinc-200 transition-all"
            >
              WALLET
            </a>
          </SignedIn>
        </div>
      </nav>
    </header>
  )
}
